'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

var _addClass = require('../helpers/dom/add-class');

var _addClass2 = _interopRequireDefault(_addClass);

var _hasClass = require('../helpers/dom/has-class');

var _hasClass2 = _interopRequireDefault(_hasClass);

var _removeClass = require('../helpers/dom/remove-class');

var _removeClass2 = _interopRequireDefault(_removeClass);

var _getParent = require('../helpers/traversal/get-parent');

var _getParent2 = _interopRequireDefault(_getParent);

var _matches = require('../helpers/traversal/matches');

var _matches2 = _interopRequireDefault(_matches);

require('../polyfills/array/from');

require('../polyfills/array/includes');

require('../polyfills/promises');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * # Accordion
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * new Spark.Accordion(el);
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module components/accordion.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @since 2.13.0
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var onOpenEvent = document.createEvent('Event');
var onCloseEvent = document.createEvent('Event');

onOpenEvent.initEvent('open', true, true);
onCloseEvent.initEvent('close', true, true);

/**
 * Private Helper Method to Expand an Accordion Drawer
 * @param {String} drawer
 * @return {Promise}
 * @private
 */
var expand = function expand(drawer) {
  var _this = this;

  var self = this;
  return new Promise(function (resolve) {
    var control = _this.el.querySelector('.spark-accordion__header[aria-controls="' + drawer + '"]');
    var content = _this.el.querySelector('#' + drawer);
    var height = Math.round(content.scrollHeight);

    control.setAttribute('aria-expanded', true);
    content.style.visibility = 'visible';
    content.style.height = height + 'px';

    content.addEventListener('transitionend', function onExpand() {
      content.removeEventListener('transitionend', onExpand);
      content.style.height = self.expanded.includes(drawer) ? 'auto' : 0 + 'px';
      onOpenEvent.drawer = drawer;
      self.el.dispatchEvent(onOpenEvent);
      resolve();
    });
  });
};

/**
 * Private Helper Method to Collapse an Accordion Drawer
 * @param {String} drawer
 * @return {Promise}
 * @private
 */
var collapse = function collapse(drawer) {
  var _this2 = this;

  var self = this;
  return new Promise(function (resolve) {
    var control = _this2.el.querySelector('.spark-accordion__header[aria-controls="' + drawer + '"]');
    var content = _this2.el.querySelector('#' + drawer);
    var height = content.scrollHeight;
    var transition = content.style.transition;

    content.style.visibility = 'visible';
    content.style.transition = '';

    content.addEventListener('transitionend', function onCollapse() {
      content.removeEventListener('transitionend', onCollapse);
      control.setAttribute('aria-expanded', false);
      content.style.visibility = 'hidden';
    });

    requestAnimationFrame(function () {
      // Define height explicitly, because transitions on "auto" won't visually animate
      content.style.height = height + 'px';

      // trigger another transition
      content.style.transition = transition;

      requestAnimationFrame(function () {
        // set height to 0, so that the transition may animate from the fixed height to 0
        content.style.height = 0 + 'px';
      });

      control.setAttribute('aria-expanded', false);
      onCloseEvent.drawer = drawer;
      self.el.dispatchEvent(onCloseEvent);
      resolve();
    });
  });
};

/**
 * Accordion
 * @class creates an Accordion
 * @extends {BaseComponent}
 */

var Accordion = function (_BaseComponent) {
  _inherits(Accordion, _BaseComponent);

  /**
   * Accordion constructor.
   * @param {Element} el
   * @param {Object} params
   * @constructor
   */
  function Accordion(el) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Accordion);

    var _this3 = _possibleConstructorReturn(this, _BaseComponent.call(this, el, params));

    _this3._bindEventListenerCallbacks();
    _this3._addEventListeners();

    if (_this3.radio) {
      _this3.multiExpand = false;
      _this3.collapsible = false;

      if (!(0, _hasClass2.default)(_this3.el, 'spark-accordion--radio')) {
        (0, _addClass2.default)(_this3.el, 'spark-accordion--radio');
      }
    }
    return _this3;
  }

  /**
   * Sets up references
   * @param  {Element} el base DOM element
   * @private
   */


  Accordion.prototype._cacheElements = function _cacheElements(el) {
    this.el = el;
    if ((0, _hasClass2.default)(this.el, 'spark-accordion--radio')) {
      this.radio = true;
    }
  };

  /**
   * Create bound versions of event listener callbacks and store them.
   * Otherwise we can't unbind from these events later because the
   * function signatures won't match.
   * @private
   */


  Accordion.prototype._bindEventListenerCallbacks = function _bindEventListenerCallbacks() {
    this._onClickBound = this._onClick.bind(this);
    this._onKeyDownBound = this._onKeyDown.bind(this);
    this._onChangeBound = this._onChange.bind(this);
    this._onOpenBound = this._onOpen.bind(this);
    this._onCloseBound = this._onClose.bind(this);
    this._onFocusBound = this._onFocus.bind(this);
    this._onBlurBound = this._onBlur.bind(this);
  };

  /**
   * Add event listeners for DOM events.
   * @private
   */


  Accordion.prototype._addEventListeners = function _addEventListeners() {
    if (this.el) {
      this.el.addEventListener('click', this._onClickBound, true);
      this.el.addEventListener('keydown', this._onKeyDownBound, true);
      this.el.addEventListener('change', this._onChangeBound, true);
      this.el.addEventListener('open', this._onOpenBound, true);
      this.el.addEventListener('close', this._onCloseBound, true);

      // Added as MS Hack, for enabling the addition and removal of a `focus` class,
      // to circumvent a lack of support in Internet Explorer & Edge for :focus-within
      // TODO: Remove focus/blur based event code & associated .focus CSS styles,
      // upon Edge browser support for :focus-within, and dropping of Internet Explorer
      this.el.addEventListener('focus', this._onFocusBound, true);
      this.el.addEventListener('blur', this._onBlurBound, true);
    }
  };

  /**
   * Remove event listeners for DOM events..
   * @private
   */


  Accordion.prototype._removeEventListeners = function _removeEventListeners() {
    if (this.el) {
      this.el.removeEventListener('click', this._onClickBound, true);
      this.el.removeEventListener('keydown', this._onKeyDownBound, true);
      this.el.removeEventListener('change', this._onChangeBound, true);
      this.el.removeEventListener('open', this._onOpenBound, true);
      this.el.removeEventListener('close', this._onCloseBound, true);
      this.el.removeEventListener('focus', this._onFocusBound, true);
      this.el.removeEventListener('blur', this._onBlurBound, true);
    }
  };

  /**
   * On Key Down (ENTER or ARROW UP/DOWN keys), trigger accordion controls
   * @param {Event} e
   * @private
   */


  Accordion.prototype._onKeyDown = function _onKeyDown(e) {
    var ENTER_KEY_CODE = 13;
    var SPACE_KEY_CODE = 32;
    var ARROW_UP_KEY_CODE = 38;
    var ARROW_DOWN_KEY_CODE = 40;

    if (this.radio && e.keyCode !== ENTER_KEY_CODE) return;

    var control = (0, _hasClass2.default)(e.target, 'spark-accordion__header') ? e.target : (0, _getParent2.default)(e.target, '.spark-accordion__header', this.el);
    var drawer = control && this._isActionable(control.getAttribute('aria-controls')) ? control.getAttribute('aria-controls') : undefined;

    if (drawer) {
      switch (e.keyCode) {
        case ENTER_KEY_CODE:
        case SPACE_KEY_CODE:
          if (this.radio) {
            this.select(drawer);
          } else {
            this.toggle(drawer);
          }
          break;
        case ARROW_DOWN_KEY_CODE:
          if (this.collapsed.includes(drawer)) {
            this.open(drawer);
          } else {
            e.preventDefault();
          }
          break;
        case ARROW_UP_KEY_CODE:
          if (this.expanded.includes(drawer)) {
            this.close(drawer);
          } else {
            e.preventDefault();
          }
          break;
      }
    }
  };

  /**
   * On Click, if target is a radio control, emulate `ENTER` key for Windows Browsers
   * @params {Object} e
   * @private
   */


  Accordion.prototype._onClick = function _onClick(e) {
    var headerClick = (0, _hasClass2.default)(e.target, 'spark-accordion__header');
    var header = headerClick ? e.target : (0, _getParent2.default)(e.target, '.spark-accordion__header', this.el);

    if (header) {
      var drawer = header.getAttribute('aria-controls');
      var isActionable = this._isActionable(drawer);

      if (isActionable && this.radio) {
        this.select(drawer);
      } else if (isActionable) {
        this.toggle(drawer);
      }
    }
  };

  /**
   * On Focus, add a class for Internet Explorer styles
   * @param {Object} e
   * @private
   */


  Accordion.prototype._onFocus = function _onFocus(e) {
    if ((0, _matches2.default)(e.target, 'header')) {
      (0, _addClass2.default)(e.target, 'focus');
    } else if ((0, _matches2.default)(e.target, '.spark-radio__input')) {
      var header = (0, _getParent2.default)(e.target, '.spark-accordion__header', this.el);
      (0, _addClass2.default)(header, 'focus');
    }
  };

  /**
   * On Blur, remove class added for Internet Explorer styles
   * @param {Object} e
   * @private
   */


  Accordion.prototype._onBlur = function _onBlur(e) {
    if ((0, _matches2.default)(e.target, 'header')) {
      (0, _removeClass2.default)(e.target, 'focus');
    } else if ((0, _matches2.default)(e.target, '.spark-radio__input')) {
      var header = (0, _getParent2.default)(e.target, '.spark-accordion__header', this.el);
      (0, _removeClass2.default)(header, 'focus');
    }
  };

  /**
   * On Radio change, make sure drawers match selection
   * @param {Event} e
   * @private
   */


  Accordion.prototype._onChange = function _onChange(e) {
    if ((0, _matches2.default)(e.target, '.spark-accordion__header > .spark-radio > .spark-radio__input')) {
      var header = (0, _getParent2.default)(e.target, '.spark-accordion__header', this.el);
      var drawer = header && this.drawers.includes(header.getAttribute('aria-controls')) ? header.getAttribute('aria-controls') : undefined;

      if (drawer) this.select(drawer);
    }
  };

  /**
   * Fire `onOpen` callback
   * @param {Event} e
   * @private
   */


  Accordion.prototype._onOpen = function _onOpen(e) {
    this.onOpen.call(this, e);
  };

  /**
   * Fire `onClose` callback
   * @param {Event} e
   * @private
   */


  Accordion.prototype._onClose = function _onClose(e) {
    this.onClose.call(this, e);
  };

  /**
   * Returns whether or not a drawer exists, and it’s current expanded/collapsed state can be changed
   * @param {String} drawer
   * @return {Boolean}
   * @private
   */


  Accordion.prototype._isActionable = function _isActionable(drawer) {
    var isExpanded = this.expanded.includes(drawer);
    var isCollapsed = this.collapsed.includes(drawer);

    if (!this.drawers.includes(drawer)) {
      return false;
    } else if (this.radio) {
      var radio = this.el.querySelector('.spark-accordion__header[aria-controls="' + drawer + '"] .spark-radio .spark-radio__input');
      return radio && !radio.checked && !radio.hasAttribute('disabled') ? true : false;
    } else if (!this.collapsible) {
      if (isExpanded && this.expanded.length === 1) {
        return false;
      } else if (isExpanded && this.expanded.length > 1) {
        return true;
      } else if (isCollapsed) {
        return true;
      }
    } else if (!this.multiExpand) {
      if (isExpanded && this.collapsible) {
        return true;
      } else if (!this.collapsible && isExpanded) {
        return false;
      } else if (isCollapsed) {
        return true;
      }
    } else {
      return true;
    }
  };

  /**
   * Return collection of all drawers
   * @return {Array}
   * @public
   */


  /**
   * Expand accordion drawer
   * @param {String} drawer
   * @return {Promise}
   * @public
   */
  Accordion.prototype.open = function open(drawer) {
    var self = this;
    return new Promise(function (resolve, reject) {
      var drawers = self.drawers;
      var expanded = self.expanded;
      var collapsed = self.collapsed;
      var isActionable = self._isActionable(drawer);

      if (!drawers.includes(drawer)) {
        reject(new Error('Drawer either does not exist, or configured incorrectly'));
      } else if (expanded.includes(drawer)) {
        resolve();
      } else if (collapsed.includes(drawer) && !isActionable) {
        reject(new Error('Drawer could not be opened'));
      } else if (collapsed.includes(drawer) && isActionable && self.radio) {
        self.select(drawer).then(resolve);
      } else if (collapsed.includes(drawer) && isActionable && self.multiExpand) {
        expand.call(self, drawer).then(resolve);
      } else if (collapsed.includes(drawer) && isActionable && !self.multiExpand) {
        if (expanded.length > 0) {
          collapse.call(self, expanded[0]).then(function () {
            expand.call(self, drawer).then(resolve);
          });
        } else {
          expand.call(self, drawer).then(resolve);
        }
      } else {
        resolve();
      }
    });
  };

  /**
   * Collapse accordion drawer
   * @param {String} drawer
   * @return {Promise}
   * @public
   */


  Accordion.prototype.close = function close(drawer) {
    var self = this;
    return new Promise(function (resolve, reject) {
      var drawers = self.drawers;
      var expanded = self.expanded;
      var collapsed = self.collapsed;
      var isActionable = self._isActionable(drawer);

      if (!drawers.includes(drawer)) {
        reject(new Error('Drawer either does not exist, or configured incorrectly'));
      } else if (collapsed.includes(drawer)) {
        resolve();
      } else if (expanded.includes(drawer) && !isActionable) {
        reject(new Error('Drawer could not be closed'));
      } else if (isActionable) {
        collapse.call(self, drawer).then(resolve);
      } else {
        resolve();
      }
    });
  };

  /**
   * Tell the accordion to toggle drawer if drawer is valid
   * @param {String} drawer
   * @public
   */


  Accordion.prototype.toggle = function toggle(drawer) {
    var self = this;

    return new Promise(function (resolve, reject) {
      var isActionable = self._isActionable(drawer);

      if (!self.drawers.includes(drawer)) {
        reject(new Error('Drawer either does not exist, or configured incorrectly'));
      } else if (self.radio && isActionable) {
        self.clearValue().then(function () {
          return self.select(drawer);
        }).then(resolve).catch(function () {
          reject(new Error('Radio Drawer could not be opened'));
        });
      } else if (self.expanded.includes(drawer) && isActionable) {
        self.close(drawer).then(resolve);
      } else if (self.expanded.includes(drawer) && !isActionable) {
        reject(new Error('Drawer could not be closed'));
      } else if (self.collapsed.includes(drawer) && isActionable) {
        if (self.multiExpand) {
          self.open(drawer).then(resolve);
        } else {
          self.hide().then(function () {
            self.open(drawer).then(resolve);
          });
        }
      } else if (self.collapsed.includes(drawer) && !isActionable) {
        reject(new Error('Drawer could not be opened'));
      }
    });
  };

  /**
   * Check radio
   * @param {String} drawer
   * @return {Promise}
   * @public
   */


  Accordion.prototype.select = function select(drawer) {
    var self = this;
    return new Promise(function (resolve, reject) {
      if (self.radio && drawer === self.expanded[0]) {
        resolve();
      } else if (self.radio && self.drawers.includes(drawer)) {
        var radio = self.el.querySelector('.spark-accordion__header[aria-controls="' + drawer + '"] .spark-radio__input:enabled');
        if (radio) {
          self.clearValue().then(function () {
            radio.checked = true;
            expand.call(self, drawer).then(resolve);
          });
        } else {
          reject(new Error('Cannot select radio button "' + drawer + '"'));
        }
      } else {
        reject(new Error('Not a radio accordion'));
      }
    });
  };

  /**
   * Uncheck all radios and collapse open drawers - only works for Radio Accordions
   * @return {Promise}
   * @public
   */


  Accordion.prototype.clearValue = function clearValue() {
    var self = this;
    return new Promise(function (resolve) {
      if (self.radio && self.expanded.length) {
        var drawer = self.expanded[0];
        var radio = self.el.querySelector('.spark-accordion__header[aria-controls="' + drawer + '"] .spark-radio__input');
        radio.checked = false;
        collapse.call(self, drawer).then(resolve);
      } else if (!self.radio) {
        console.info('clearValue() only effects radio accordions, but was run anyway');
      } else {
        resolve();
      }
    });
  };

  /**
   * Expand all drawers (Chevron - `multiExpand`) or enable radio buttons (Radio)
   * @return {Promise}
   * @public
   */


  Accordion.prototype.show = function show() {
    var self = this;
    return new Promise(function (resolve, reject) {
      if (self.radio) {
        var radioButtons = self.el.querySelectorAll('.spark-accordion__header .spark-radio__input');
        if (radioButtons.length >= 1) {
          radioButtons.forEach(function (radio) {
            return radio.removeAttribute('disabled');
          });
          resolve();
        } else {
          reject(new Error('Accordion is either misconfigured, or there are no drawers to enable'));
        }
      } else if (self.multiExpand) {
        var collapsed = self.collapsed;
        switch (collapsed.length) {
          case 0:
            resolve();
            break;
          case 1:
            expand.call(self, collapsed[0]).then(resolve);
            break;
          default:
            {
              var changes = [];
              do {
                changes.push(expand.call(self, collapsed.shift()));
              } while (collapsed.length);

              Promise.all(changes).then(resolve).catch(reject);
              break;
            }
        }
      } else {
        var expanded = self.expanded;
        if (expanded.length && expanded[0] !== self.drawers[0]) {
          collapse.call(self, expanded[0]);
          expand.call(self, self.drawers[0]).then(resolve);
        } else if (expanded.length) {
          resolve();
        } else {
          reject(new Error('Accordion is either misconfigured, or there are no drawers to open'));
        }
      }
    });
  };

  /**
   * Collapse all drawers (Chevron) or disable radio buttons (radio)
   * @return {Promise}
   * @public
   */


  Accordion.prototype.hide = function hide() {
    var self = this;
    return new Promise(function (resolve, reject) {
      if (self.radio) {
        var radioButtons = self.el.querySelectorAll('.spark-accordion__header .spark-radio__input');
        if (radioButtons.length >= 1) {
          radioButtons.forEach(function (button) {
            var disabled = document.createAttribute('disabled');
            button.attributes.setNamedItem(disabled);
          });
          resolve();
        } else {
          reject(new Error('Accordion is either misconfigured, or there are no drawers to disable'));
        }
      } else {
        var expanded = self.expanded;
        switch (expanded.length) {
          case 0:
            resolve();
            break;
          case 1:
            collapse.call(self, expanded[0]).then(resolve);
            break;
          default:
            {
              var changes = [];
              do {
                changes.push(collapse.call(self, expanded.shift()));
              } while (expanded.length);

              Promise.all(changes).then(resolve).catch(reject);
              break;
            }
        }
      }
    });
  };

  /**
   * Remove component from DOM.
   * @param {Boolean} leaveElement
   * @public
   */


  Accordion.prototype.remove = function remove(leaveElement) {
    return _BaseComponent.prototype.remove.call(this, leaveElement);
  };

  /**
   * Update the element in use and the position.
   * @param {Element} el
   * @public
   */


  Accordion.prototype.update = function update(el, params) {
    return _BaseComponent.prototype.update.call(this, el, params);
  };

  _createClass(Accordion, [{
    key: 'drawers',
    get: function get() {
      var drawerControls = this.el.querySelectorAll('.spark-accordion__header');
      var drawerContents = this.el.querySelectorAll('.spark-accordion__content');
      var drawerNames = drawerControls.length ? Array.from(drawerControls).map(function (control) {
        return control.getAttribute('aria-controls');
      }) : [];
      return drawerNames.filter(function (drawer) {
        return Array.from(drawerContents).some(function (content) {
          return content.id === drawer;
        });
      });
    }

    /**
     * Return collection of currently expanded drawers
     * @return {Array}
     * @public
     */

  }, {
    key: 'expanded',
    get: function get() {
      var openDrawerControls = this.el.querySelectorAll('.spark-accordion__header[aria-expanded="true"]');
      return openDrawerControls.length ? Array.from(openDrawerControls).map(function (control) {
        return control.getAttribute('aria-controls');
      }) : [];
    }

    /**
     * Explicitly set which drawers are currently expanded
     * @param {Array} drawers
     * @public
     */
    ,
    set: function set(drawers) {
      var _this4 = this;

      if (!this.radio) {
        var toClose = this.expanded.filter(function (expanded) {
          return !drawers.includes(expanded);
        });
        toClose.forEach(function (drawer) {
          return _this4.close(drawer);
        });
        drawers.forEach(function (drawer) {
          return _this4.open(drawer);
        });
      } else if (drawers.length >= 1) {
        this.select(drawers.pop());
      }
    }

    /**
     * Return collection of currently collapsed drawers
     * @return {Array}
     * @public
     */

  }, {
    key: 'collapsed',
    get: function get() {
      var openDrawerControls = this.el.querySelectorAll('.spark-accordion__header[aria-expanded="false"]');
      return openDrawerControls.length ? Array.from(openDrawerControls).map(function (control) {
        return control.getAttribute('aria-controls');
      }) : [];
    }

    /**
     * Explicitly set which drawers are currently expanded
     * @param {Array} drawers
     * @public
     */
    ,
    set: function set(drawers) {
      var _this5 = this;

      if (!this.radio) {
        var toOpen = this.collapsed.filter(function (collapsed) {
          return !drawers.includes(collapsed);
        });
        toOpen.forEach(function (drawer) {
          return _this5.open(drawer);
        });
        drawers.forEach(function (drawer) {
          return _this5.close(drawer);
        });
      } else {
        throw new Error('Cannot be used to control radio accordions');
      }
    }

    /**
     * Returns the current radio value
     * @return {String}
     * @public
     */

  }, {
    key: 'selected',
    get: function get() {
      if (!this.radio) {
        return undefined;
      } else {
        var checkedRadio = this.el.querySelector('.spark-accordion__header .spark-radio > .spark-radio__input:checked');
        return checkedRadio ? checkedRadio.value : undefined;
      }
    }

    /**
     * Activate an accordion drawer by radio value
     * @param {String} value
     * @public
     */
    ,
    set: function set(value) {
      if (!this.radio) {
        return;
      } else if (!value) {
        this.clearValue();
      } else {
        var radio = this.el.querySelector('.spark-accordion__header .spark-radio > .spark-radio__input[value="' + value + '"]');
        var drawer = (0, _getParent2.default)(radio, '.spark-accordion__header', this.el).getAttribute('aria-controls');
        if (this.drawers.includes(drawer)) this.select(drawer);
      }
    }
  }]);

  return Accordion;
}(_base2.default);

/**
 * Whitelisted parameters which can be set on construction.
 * @type {Array}
 */


Accordion.prototype._whitelistedParams = ['radio', 'multiExpand', 'collapsible', 'onOpen', 'onClose'];

/**
 * Default values for internal properties we will be setting.
 * These are set on each construction so we don't leak properties
 * into the prototype chain.
 * @type {Object}
 */
Accordion.prototype.defaults = {
  el: null,
  radio: false,
  multiExpand: true,
  collapsible: true,
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};

exports.default = Accordion;
module.exports = exports['default'];
//# sourceMappingURL=accordion.js.map



//////////////////
// WEBPACK FOOTER
// ./~/@sabre/aven-spark/js/dist/components/accordion.js
// module id = 841
// module chunks = 0